import { useCallback } from 'react';
import { batch } from 'react-redux';
import { useAppDispatch, useAppSelector } from 'redux/reduxHooks';
import {
  pushStep,
  STEPS,
  updateIsDone,
  updateStep3,
} from 'redux/bookingFormSlice';
import { createPendingBookingAPI } from 'services/APIs';
import { ICreateBookingData } from 'interfaces/createBookingDataTypes';
import { loadOtpToken } from 'utils/storage';

export const useChargeFirstBooking = () => {
  const dispatch = useAppDispatch();
  const {
    bookingFormSlice: {
      step1: { phoneNumber },
      step3: { pendingBookingPayload, tempAccessToken },
    },
  } = useAppSelector((state) => state);

  const finalizeChargeFirstBooking = useCallback(
    async (overridePayload?: ICreateBookingData) => {
      const payload = overridePayload ?? pendingBookingPayload;

      if (!payload) {
        throw new Error('Missing booking details');
      }

      const response = await createPendingBookingAPI(payload, {
        otpToken: loadOtpToken(phoneNumber),
        tempAccessToken,
      });

      if (response.clientSecret) {
        batch(() => {
          dispatch(
            updateStep3({
              pendingBookingId: response.pendingBookingId,
              clientSecret: response.clientSecret,
              stripeAccount: response.stripeAccount,
            })
          );
          dispatch(pushStep(STEPS.PAYMENT));
        });
        return;
      }

      batch(() => {
        dispatch(updateStep3({ bookingId: response.id }));
        dispatch(updateIsDone());
      });
    },
    [dispatch, pendingBookingPayload, phoneNumber, tempAccessToken]
  );

  return { finalizeChargeFirstBooking };
};
